import { IAPIRequestMetaData } from "redux/_core/api/types";
import { getType } from "typesafe-actions";
import vdmDashboardActions from "./actions";
import {
	ICNRForDateRangeParams,
	IVDMBunkerData,
	IVDMDashboardContent,
	IVDMDashboardLoadParams,
	IVDMPICContent,
	IVDMPICSaveParams,
	IVDMVesselStatus,
} from "./@types";
import { commonUtils } from "redux/_common";

const vdmDashboardAPIS = {
	loadVDMVesselStatus(
		vesselId?: string,
	): IAPIRequestMetaData<IVDMVesselStatus[]> {
		return {
			url: `https://run.mocky.io/v3/ec65228d-31a2-4bc8-8a7c-22e2b7f5104a`,
			// url: `https://68087342942707d722de3eb9.mockapi.io/api/v1/vessel-status`,
			feature: getType(vdmDashboardActions.commands.vesselVDMStatusLoad),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadVDMBunkerTab(vesselId: string): IAPIRequestMetaData<IVDMBunkerData> {
		return {
			url: `https://run.mocky.io/v3/2f6f64a5-e547-42bd-a2da-b92f27819730`,
			feature: getType(vdmDashboardActions.commands.vdmBunkerTabLoad),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadVDMConsumptionTab(
		vesselId: string,
	): IAPIRequestMetaData<IVDMVesselStatus[]> {
		return {
			url: `https://run.mocky.io/v3/472a547b-08bf-4ca6-94aa-3c972ab92728`,
			feature: getType(vdmDashboardActions.commands.vdmConsumptionTabLoad),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadVDMSmartAlerts(vesselId: string): IAPIRequestMetaData<any> {
		return {
			url: `https://run.mocky.io/v3/705a4eea-18db-4b55-a432-ac5c768a80fa`,
			feature: getType(vdmDashboardActions.commands.vdmSmartAlertsLoad),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadFuelConsumptionDistanceCovered(
		vesselId: string,
	): IAPIRequestMetaData<any> {
		return {
			url: `https://run.mocky.io/v3/f7427535-b6b2-4834-81fc-447ab09682c9`,
			feature: getType(
				vdmDashboardActions.commands.vdmFuelConsumptionDistanceCoveredLoad,
			),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadDraftSpeedImpactOnFuelConsumption(
		vesselId: string,
	): IAPIRequestMetaData<any> {
		return {
			url: `https://run.mocky.io/v3/43891240-9481-4b19-90a2-a9ca28583aeb`,
			feature: getType(
				vdmDashboardActions.commands.vdmDraftSpeedImpactOnFuelConsumptionLoad,
			),
			method: "GET",
			// queryParams: {
			// 	vesselId,
			// },
		};
	},
	loadCNRForGivenDateRange(
		params: ICNRForDateRangeParams & { token: string; userId: string },
	): IAPIRequestMetaData<any> {
		const { vesselId, token, userId, end, start } = params;
		return {
			url: `${commonUtils.getAPIBaseUrl()}/api/signalreports`,
			feature: getType(vdmDashboardActions.commands.vdmCNRDateRangeLoad),
			method: "GET",
			queryParams: {
				vesselId,
				startDate: start,
				endDate: end,
			},
			headers: {
				// @ts-ignore
				"x-token": token,
				"x-user-id": userId,
			},
		};
	},
	loadVDMDashboard(
		params: IVDMDashboardLoadParams & { token: string },
	): IAPIRequestMetaData<IVDMDashboardContent> {
		const { vesselId, cnrId, token } = params;
		return {
			url: `${commonUtils.getAPIBaseUrl()}/api/vdm`,
			feature: getType(vdmDashboardActions.commands.vdmDashboardLoad),
			method: "GET",
			queryParams: {
				vesselId,
				cnrId,
			},
			headers: {
				// @ts-ignore
				"x-token": token,
				// "x-user-id": userId,
			},
		};
	},
	loadVDMPIC(
		params: IVDMDashboardLoadParams & { token: string },
	): IAPIRequestMetaData<IVDMPICContent> {
		const { vesselId, token } = params;
		return {
			url: `${commonUtils.getAPIBaseUrl()}/api/pic`,
			feature: getType(vdmDashboardActions.commands.vdmPICLoad),
			method: "GET",
			queryParams: {
				vesselId,
			},
			headers: {
				// @ts-ignore
				"x-access-token": token,
			},
		};
	},
	saveVDMPIC(
		params: IVDMPICSaveParams & { token: string; departments: any },
	): IAPIRequestMetaData<IVDMPICContent> {
		const { vesselId, token, departments } = params;

		const body = {
			vesselId,
			departments,
		};

		const stringifiedBody = JSON.stringify(body);

		return {
			url: `${commonUtils.getAPIBaseUrl()}/api/pic`,
			feature: getType(vdmDashboardActions.commands.vdmPICSave),
			method: "PATCH",
			queryParams: {
				vesselId,
			},
			headers: {
				"Content-Type": "application/json",
				// @ts-ignore
				"x-access-token": token,
			},
			body: stringifiedBody,
		};
	},
	uploadVDMPICProfilePicture(params: {
		formData: FormData;
		token: string;
	}): IAPIRequestMetaData<IVDMPICContent> {
		const { formData, token } = params;

		return {
			url: `${commonUtils.getAPIBaseUrl()}/api/pic-profile-picture`,
			feature: getType(vdmDashboardActions.commands.uploadPICProfilePicture),
			method: "POST",
			headers: {
				// @ts-ignore
				"x-access-token": token,
			},
			body: formData,
		};
	},
};

export default vdmDashboardAPIS;
